export default __webpack_public_path__ + "static/media/loader.eaa65fa0.svg";